<template>
  <div class="basic_con">
    <Frame title="客户资产">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <div class="item_wrapper">
            <div class="left">
              <el-image class="icon" src="/img/factoring/fcxx.png"></el-image>
              <div class="name">房产信息</div>
            </div>
            <div class="right">
              <div class="record">
                房产记录<span>{{ dataInfo.custHouseBlList?dataInfo.custHouseBlList.length:0 }}</span> 条
              </div>
              <div class="evaluate">
                市场总估价<span>{{ conversion(houseCount) }}</span> 万元
              </div>
            </div>
          </div>
          <div class="item_wrapper item_wrapper_blue">
            <div class="left">
              <el-image class="icon" src="/img/factoring/clxx.png"></el-image>
              <div class="name">车辆信息</div>
            </div>
            <div class="right">
              <div class="record">
                车辆记录<span>{{ dataInfo.custCarBlList?dataInfo.custCarBlList.length:0 }}</span> 条
              </div>
              <div class="evaluate">
                市场总估价<span>{{ conversion(carCount) }}</span> 万元
              </div>
            </div>
          </div>
          <div class="item_wrapper item_wrapper_green">
            <div class="left">
              <el-image class="icon" src="/img/factoring/tdxx.png"></el-image>
              <div class="name">土地信息</div>
            </div>
            <div class="right">
              <div class="record">
                土地记录<span>{{ dataInfo.custLandBlList?dataInfo.custLandBlList.length:0 }}</span> 条
              </div>
              <div class="evaluate">
                市场总估价<span>{{ conversion(landCount) }}</span> 万元
              </div>
            </div>
          </div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import { floatAdd } from "@/util/util";
export default {
  name: "customerGrade",
  components: {
    Frame,
  },
  data() {
    return {
      houseCount: 0,
      landCount: 0,
      carCount: 0,
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {
          custHouseBlList: [],
          custLandBlList: [],
          custCarBlList: [],
        };
      },
    },
  },
  computed: {
    conversion() {
      return function (val, company = 1) {
        return val > 0
          ? Intl.NumberFormat("en", { maximumFractionDigits: 2 }).format(
              (Number(val) / company).toFixed(2)
            )
          : val;
      };
    },
  },
  watch: {
    dataInfo: {
      immediate: true,
      handler(newName, oldName) {
        let houseCount = 0;
        this.dataInfo.custHouseBlList.map((item) => {
          houseCount=floatAdd(houseCount,Number(item.marketMoney)) ;
        });
        this.houseCount = houseCount;

        let landCount = 0;
        this.dataInfo.custLandBlList.map((item) => {
          landCount=floatAdd(landCount, Number(item.marketMoney));
        });
        this.landCount = landCount;

        let carCount = 0;
        this.dataInfo.custCarBlList.map((item) => {
          carCount =floatAdd(carCount,Number(item.marketMoney)) ;
        });
        this.carCount = carCount;
       
      },
    },
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.con_wrapper {
  display: flex;
  justify-content: space-around;
  padding: 40px 0 60px 0;
  .item_wrapper {
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    flex: 1;
    max-width: 350px;
    height: 131px;
    background: inherit;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 237, 237, 1);
    border-radius: 10px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: "微软雅黑", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-align: left;
    line-height: 20px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 131px;
      background: inherit;
      background-color: rgba(255, 237, 237, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(255, 237, 237, 1);
      border-radius: 10px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-family: "微软雅黑", sans-serif;
      font-weight: 400;
      font-style: normal;
      text-align: left;
      line-height: 20px;
      .icon {
        width: 40px;
        height: 36px;
      }
      .name {
        color: #fd8686;
        font-size: 14px;
        margin-top: 16px;
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .record {
        font-weight: 400;
        font-size: 12px;
        color: rgba(102, 102, 102, 0.8);
        span {
          font-weight: 700;
          font-size: 20px;
          padding: 0 4px;
        }
      }
      .evaluate {
        font-weight: 400;
        font-size: 12px;
        color: rgba(102, 102, 102, 0.8);
        span {
          font-weight: 400;
          font-size: 16px;
          padding: 0 4px;
        }
      }
    }
  }
  .item_wrapper_blue {
    border-color: rgba(208, 231, 255, 1);
    .left {
      background-color: rgba(208, 231, 255, 1);
      border-color: rgba(208, 231, 255, 1);
      .name {
        color: #409eff;
      }
    }
  }
  .item_wrapper_green {
    border-color: rgba(225, 249, 237, 1);
    .left {
      background-color: rgba(225, 249, 237, 1);
      border-color: rgba(225, 249, 237, 1);
      .name {
        color: #70be94;
      }
    }
  }
}
</style>

